var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "tableContainer", staticClass: "jeepay-table-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showStickyHeader,
              expression: "showStickyHeader",
            },
          ],
          ref: "stickyHeader",
          staticClass: "sticky-header",
        },
        [
          _c(
            "div",
            {
              staticClass: "sticky-header-content",
              style: { transform: `translateX(-${_vm.scrollLeft}px)` },
            },
            [
              _c("table", { staticClass: "custom-header-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.alignedTableColumns, function (column, index) {
                      return _c(
                        "th",
                        {
                          key: index,
                          class: [
                            column.fixed === "left" || column.fixed === true
                              ? "sticky-left"
                              : "",
                            column.fixed === "right" ? "sticky-right" : "",
                          ],
                          style: {
                            textAlign: column.align || "center",
                            ...(column.fixed
                              ? {
                                  position: "sticky",
                                  [column.fixed === "left" ||
                                  column.fixed === true
                                    ? "left"
                                    : "right"]:
                                    column.fixed === "left" ||
                                    column.fixed === true
                                      ? _vm.getColumnLeftPosition(index)
                                      : 0,
                                  zIndex: 2,
                                }
                              : {}),
                          },
                          attrs: { width: column.width || "200" },
                        },
                        [
                          column.slots && column.slots.title
                            ? [_vm._t(column.slots.title)]
                            : [_vm._v(" " + _vm._s(column.title) + " ")],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "a-table",
        {
          ref: "innerTable",
          attrs: {
            columns: _vm.alignedTableColumns,
            "data-source": _vm.apiResData.records,
            pagination: _vm.pagination,
            loading: _vm.showLoading,
            "row-selection": _vm.rowSelection,
            rowKey: _vm.rowKey,
            "default-align": "center",
            scroll: { x: _vm.scrollX },
            customRow: (record, index) => {
              if (!_vm.tableRowCrossColor) {
                return {}
              }
              return {
                style: {
                  "background-color": index % 2 == 0 ? "#FCFCFC" : "#FFFFFF",
                },
              }
            },
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.columnsCustomSlots, function (colCustom) {
                return {
                  key: colCustom.customRender,
                  fn: function (record) {
                    return [
                      _vm._t(colCustom.customRender, null, { record: record }),
                    ]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        [
          _vm._l(_vm.columnsTitleSlots, function (titleSlot) {
            return _c(
              "template",
              { slot: titleSlot.title },
              [_vm._t(titleSlot.title)],
              2
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }